import { Name, translationKeys } from '@ori-events/show-error-notification';
export { translationKeys };
export const errorNotificationTimeOut = 3000;
export const showErrorNotification = message => {
  if (typeof window !== 'object') {
    return;
  }
  window.dispatchEvent(new CustomEvent(Name, {
    detail: {
      message: message ?? translationKeys.genericError,
      notificationOptions: {
        delay: errorNotificationTimeOut
      }
    }
  }));
};
//# sourceMappingURL=showErrorNotification.js.map